import React from "react";

const SECTION_LABELS = [
  ["title_what_is_it", "What Is It"],
  ["simple_analogy", "Simple Analogy"],
  ["brief_history", "Brief History"],
  ["how_it_works", "How It Works"],
  ["industry_usage_today", "Industry Usage Today"],
  ["advantages", "Advantages"],
  ["disadvantages", "Disadvantages"],
  ["when_to_use_it", "When To Use It"],
];

export default function LessonSections({ lesson }) {
  if (!lesson) return null;
  const sections = lesson.sections || {};

  return (
    <article className="lesson">
      <header className="lesson-header">
        <p className="lesson-date">{lesson.date}</p>
        <h1>{lesson.topic}</h1>
      </header>

      {lesson.image_key && (
        <img
          className="lesson-diagram"
          src={`/${lesson.image_key}`}
          alt={`Architecture diagram for ${lesson.topic}`}
        />
      )}

      {SECTION_LABELS.map(([key, label]) => (
        <section key={key} className="lesson-section">
          <h2>{label}</h2>
          <p>{sections[key]}</p>
        </section>
      ))}

      {Array.isArray(lesson.exam_tips) && lesson.exam_tips.length > 0 && (
        <section className="lesson-section exam-tips">
          <h2>Top 5 Things to Remember for the AWS Exam</h2>
          <ol className="exam-tips-list">
            {lesson.exam_tips.map((tip, i) => (
              <li key={i}>{tip}</li>
            ))}
          </ol>
        </section>
      )}
    </article>
  );
}
